import styled from "styled-components";

const ProductTypePanelStyled = styled.div`

`;

export default ProductTypePanelStyled;